import { format, addDays } from 'date-fns';

const today = new Date();

const initialState = {
  subject: null,
  ascending: true,
  includeCancelled: false,
  earliestDate: format(today, 'yyyy-MM-dd'),
  latestDate: format(addDays(today, 14), 'yyyy-MM-dd'),
};

export default initialState;
